import * as React from 'react';
import type { Product } from '@/types'
import { ProductCard } from '@/web/components/molecules/ProductCard';
import { LoadingScreen } from '@/web/components/molecules/LoadingScreen';

export interface ProductsListProps {
  products: Product[];
  handleEditProduct: (product: Product) => () => void;
  isLoading?: boolean;
}

export function ProductsList(props: ProductsListProps) {

  if (props.isLoading) {
    return <LoadingScreen />
  }

  const products = props.products;

  if (products.length) {
    return (<div className="products-list w-full">
      <div className="flex flex-row">
        <div className="flex-1">
          <div className="mt-2">
            {products.map(product => <ProductCard product={product} />)}
          </div>
        </div>
      </div>
    </div>)
  }
  return (<div className="flex justify-center align-middle">
    <h1 className="text-2xl">No products found.</h1>
  </div>)
}
